// UI
import Breadcrumbs from '@/components/ui/Breadcrumbs'
import Iframe from '@/components/ui/Iframe'

export default function Index() {
    const breadcrumbs = [
        {
            label: 'Statistiques revendeurs',
        },
    ]

    const iframeUrl =
        'https://metabase.baltic-watches.com/embed/dashboard/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZXNvdXJjZSI6eyJkYXNoYm9hcmQiOjY2fSwicGFyYW1zIjp7fX0.DxE5zYwx-bC3E9iqLmhWwENBgaCdb8DTHLy6HfW8uk0#bordered=false&titled=false'

    return (
        <div className="h-[calc(100vh-190px)]">
            <Breadcrumbs breadcrumbs={breadcrumbs} />

            <div className="h-full p-5">
                <Iframe
                    title="Statistiques revendeurs"
                    fullHeight={true}
                    src={iframeUrl}
                />
            </div>
        </div>
    )
}
